import React, { useContext, useState, useEffect } from "react";
import { App } from "antd";
import { Unity, useUnityContext } from "react-unity-webgl";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../../config/AuthContext";
import RecompensaSummaryModal from "../jutge/activitatsId/content/RecompensaSummaryModal";
import GameModalFrame from "./content/GameModalFrame";

const ZeldaUnityGameCore: React.FC = () => {
  const { message } = App.useApp();
  const { userId, alumne } = useContext(AuthContext);
  const [iframeUrl, setIframeUrl] = useState<string | null>(null);
  const [activeExercise, setActiveExercise] = useState<{ problemaId: string | number; actividadId: string | number } | null>(null);
  const [showJavashop, setShowJavashop] = useState<boolean>(false);
  const [showInventory, setShowInventory] = useState<boolean>(false);
  const [showJavadex, setShowJavadex] = useState<boolean>(false);
  const [showMochila, setShowMochila] = useState<boolean>(false);
  const [showJavamons, setShowJavamons] = useState<boolean>(false);
  const [showActivityModal, setShowActivityModal] = useState<boolean>(false);
  const [activeActivityId, setActiveActivityId] = useState<string | null>(null);
  const [showActivitiesModal, setShowActivitiesModal] = useState<boolean>(false);
  // Iframe de CAPTURA (opción B): elegir JAVAball; Unity reproduce la animación de captura/escape.
  const [captureUrl, setCaptureUrl] = useState<string | null>(null);
  const [loadingCapture, setLoadingCapture] = useState<boolean>(true);
  // Menú de PAUSA (Escape) como modal React con estética RPG.
  const [showGameMenu, setShowGameMenu] = useState<boolean>(false);

  // Estados de carga para los iframes modales
  const [loadingTheia, setLoadingTheia] = useState<boolean>(true);
  const [loadingShop, setLoadingShop] = useState<boolean>(true);
  const [loadingInventory, setLoadingInventory] = useState<boolean>(true);
  const [loadingJavadex, setLoadingJavadex] = useState<boolean>(true);
  const [loadingMochila, setLoadingMochila] = useState<boolean>(true);
  const [loadingJavamons, setLoadingJavamons] = useState<boolean>(true);
  const [loadingActivity, setLoadingActivity] = useState<boolean>(true);
  const [loadingActivitiesModal, setLoadingActivitiesModal] = useState<boolean>(true);

  // Estado para el modal de recompensa (mismo que RecompensaSummaryModal)
  const [recompensaModalVisible, setRecompensaModalVisible] = useState<boolean>(false);
  const [recompensaItems, setRecompensaItems] = useState<any[]>([]);
  const [recompensaLoading, setRecompensaLoading] = useState<boolean>(false);
  const [recompensaStatus, setRecompensaStatus] = useState<string>("ok");
  const [recompensaEmptyReason, setRecompensaEmptyReason] = useState<string | undefined>(undefined);
  const [recompensaMessage, setRecompensaMessage] = useState<string | undefined>(undefined);
  // Modo seleccionable (grupo_seleccion > 0): el usuario elige qué recompensa quiere
  const [recompensaSelectableMode, setRecompensaSelectableMode] = useState<boolean>(false);
  const [recompensaSelectionOptions, setRecompensaSelectionOptions] = useState<any[]>([]);
  const [recompensaGuaranteedRewards, setRecompensaGuaranteedRewards] = useState<any[]>([]);
  const [recompensaPendingChestData, setRecompensaPendingChestData] = useState<any>(null);

  // El panel pequeño del juego (theia-panel) se agranda cuando abre un sub-modal
  // (ver enunciado / ver código enviado) para que se vea bien, y vuelve a su
  // tamaño compacto al cerrarlo.
  const [panelExpanded, setPanelExpanded] = useState<boolean>(false);

  // Modal de DERROTA en el battleground
  const [showDefeatModal, setShowDefeatModal] = useState<boolean>(false);
  const [defeatReason, setDefeatReason] = useState<string>("Has sido derrotado en combate.");

  // Modal del SANTUARIO con barra de progreso
  const [showSanctuaryModal, setShowSanctuaryModal] = useState<boolean>(false);
  const [sanctuaryData, setSanctuaryData] = useState<{
    heartsToRecover: number;
    totalSeconds: number;
    currentHp: number;
    maxHp: number;
  }>({ heartsToRecover: 1, totalSeconds: 30, currentHp: 1, maxHp: 3 });
  const [sanctuaryProgress, setSanctuaryProgress] = useState<number>(0);
  const [sanctuarySecondsLeft, setSanctuarySecondsLeft] = useState<number>(30);

  // Modal de DESBLOQUEO POR CÓDIGO (tipo interactuable LootConCodigo)
  const [showCodeUnlock, setShowCodeUnlock] = useState<boolean>(false);
  const [codeUnlockValue, setCodeUnlockValue] = useState<string>("");
  const [codeUnlockError, setCodeUnlockError] = useState<string>("");
  const [codeUnlockSubmitting, setCodeUnlockSubmitting] = useState<boolean>(false);

  const { unityProvider, isLoaded, loadingProgression, addEventListener, removeEventListener, sendMessage } = useUnityContext({
    loaderUrl: "/unitybuild/Build/unitybuild.loader.js",
    dataUrl: "/unitybuild/Build/unitybuild.data",
    frameworkUrl: "/unitybuild/Build/unitybuild.framework.js",
    codeUrl: "/unitybuild/Build/unitybuild.wasm",
    companyName: "Lanterns",
    productName: "Zelda",
    productVersion: "1.0",
  });

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  // Prioritize pending_game_aulaId over URL param, and clear it so we don't reuse it by accident if we refresh
  const [aulaId, setAulaId] = useState<string | null>(queryParams.get("aulaId"));

  useEffect(() => {
    const pending = localStorage.getItem('pending_game_aulaId');
    if (pending) {
      setAulaId(pending);
      localStorage.removeItem('pending_game_aulaId');
    }
  }, []);

  // Auto-login en Unity: en el build WebGL el juego NO muestra formulario de
  // usuario/contraseña, sino que recibe el usuario ya autenticado desde la web.
  // Enviamos el AutoLogin en cuanto Unity está cargado y tenemos userId + token.
  // El aulaId es opcional (Unity lo resuelve por su backend si llega vacío), por eso
  // no bloqueamos el envío a que exista aulaId.
  useEffect(() => {
    if (isLoaded && unityProvider && userId) {
      const token = localStorage.getItem('authToken');
      if (token) {
        // Nombre visible del jugador para el nameplate del multijugador (tecla ".").
        const a: any = alumne?.alumne || {};
        const userName = `${a.nom || ''} ${a.cognoms || ''}`.trim() || a.usu || "";
        const payload = JSON.stringify({ userId, aulaId: aulaId || "", token, userName });
        sendMessage("LoginManagerGO", "AutoLogin", payload);
      }
    }
  }, [isLoaded, unityProvider, aulaId, userId, alumne, sendMessage]);

  // Prewarm Theia on game load + keep ECS task alive with periodic heartbeats during the session.
  // The ECS inactivity timer (checkInactivity) stops the task after 30 min of no heartbeat,
  // so we send one every 10 min while the game is open — even when the IDE iframe is closed.
  // This way switching between exercises is always fast (~3s API latency, no cold start).
  React.useEffect(() => {
    if (!userId) return;
    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost';
    const token = localStorage.getItem('authToken');

    // Prewarm: start the ECS task immediately on login so it's ready before the first exercise
    fetch(`${baseUrl}:8061/jutge/theia/port?id_usuari=${userId}&folder=prewarm&id_problema=0&admin=true`, {
      headers: { 'Authorization': token ? token : '' }
    }).catch(err => console.error('[ZeldaUnityGame] Error prewarming Theia:', err));

    // Heartbeat every 10 min to prevent inactivity-based shutdown during the session
    const heartbeatInterval = setInterval(() => {
      const t = localStorage.getItem('authToken');
      fetch(`${baseUrl}:8061/jutge/ide/heartbeat?id_usuari=${userId}`, {
        method: 'POST',
        headers: { 'Authorization': t ? t : '' }
      }).catch(err => console.warn('[ZeldaUnityGame] Heartbeat failed:', err));
    }, 10 * 60 * 1000); // every 10 minutes

    return () => clearInterval(heartbeatInterval);
  }, [userId]);

  React.useEffect(() => {
    function handleOpenTheia(payloadJson: any) {
      try {
        const data = typeof payloadJson === "string" ? JSON.parse(payloadJson) : payloadJson;
        console.log("[ZeldaUnityGame] Unity solicita abrir el panel de ejercicio:", data);

        // Abrir TheiaGamePanel directamente: el panel gestiona el provisioning internamente
        const panelUrl = `${window.location.origin}/game/theia-panel?idActivitat=${data.actividadId}&idProblema=${data.problemaId}`;
        setActiveExercise({ problemaId: data.problemaId, actividadId: data.actividadId });
        setLoadingTheia(true);
        setIframeUrl(panelUrl);

        // Cerrar popup de Unity inmediatamente (sin esperar a Theia)
        if (isLoaded && unityProvider) {
          sendMessage("MultiplayerManager", "HideTheiaPopup");
        }
      } catch (e) {
        console.error("[ZeldaUnityGame] Error parseando payload de Unity:", e);
      }
    }

    addEventListener("OpenTheiaExercise", handleOpenTheia);
    return () => {
      removeEventListener("OpenTheiaExercise", handleOpenTheia);
    };
  }, [addEventListener, removeEventListener, unityProvider, isLoaded, sendMessage]);

  // Listener para abrir la Javashop desde Unity
  useEffect(() => {
    function handleOpenJavashop() {
      setLoadingShop(true);
      setShowJavashop(true);
      if (isLoaded && unityProvider) {
        sendMessage("MultiplayerManager", "PauseGame");
      }
    }

    addEventListener("OpenJavashop", handleOpenJavashop);
    return () => {
      removeEventListener("OpenJavashop", handleOpenJavashop);
    };
  }, [addEventListener, removeEventListener, isLoaded, unityProvider, sendMessage]);

  // Listener para abrir/cerrar el Inventario (Equipamiento RPG) desde Unity (tecla I).
  // Unity siempre envía "Open..."; aquí decidimos abrir o cerrar (toggle) según el estado actual.
  useEffect(() => {
    function handleOpenInventory() {
      setShowInventory((prev) => {
        if (prev) {
          // Ya estaba abierto -> segunda pulsación cierra
          if (isLoaded && unityProvider) {
            sendMessage("LoginManagerGO", "RefreshPlayerData", "");
            sendMessage("MultiplayerManager", "UnpauseGame");
          }
          return false;
        }
        setLoadingInventory(true);
        if (isLoaded && unityProvider) {
          sendMessage("MultiplayerManager", "PauseGame");
        }
        return true;
      });
    }

    addEventListener("OpenInventory", handleOpenInventory);
    return () => {
      removeEventListener("OpenInventory", handleOpenInventory);
    };
  }, [addEventListener, removeEventListener, isLoaded, unityProvider, sendMessage]);

  // Listener para abrir/cerrar la JAVAdex desde Unity (tecla P) — toggle.
  useEffect(() => {
    function handleOpenJavadex() {
      setShowJavadex((prev) => {
        if (prev) {
          if (isLoaded && unityProvider) {
            sendMessage("MultiplayerManager", "UnpauseGame");
          }
          return false;
        }
        setLoadingJavadex(true);
        if (isLoaded && unityProvider) {
          sendMessage("MultiplayerManager", "PauseGame");
        }
        return true;
      });
    }

    addEventListener("OpenJavadex", handleOpenJavadex);
    return () => {
      removeEventListener("OpenJavadex", handleOpenJavadex);
    };
  }, [addEventListener, removeEventListener, isLoaded, unityProvider, sendMessage]);

  // Listener para abrir/cerrar la Mochila RPG desde Unity (tecla N) — toggle.
  useEffect(() => {
    function handleOpenMochila() {
      setShowMochila((prev) => {
        if (prev) {
          if (isLoaded && unityProvider) {
            sendMessage("MultiplayerManager", "UnpauseGame");
          }
          return false;
        }
        setLoadingMochila(true);
        if (isLoaded && unityProvider) {
          sendMessage("MultiplayerManager", "PauseGame");
        }
        return true;
      });
    }
    addEventListener("OpenMochila", handleOpenMochila);
    return () => {
      removeEventListener("OpenMochila", handleOpenMochila);
    };
  }, [addEventListener, removeEventListener, isLoaded, unityProvider, sendMessage]);

  // Listener para abrir/cerrar los Javamons RPG desde Unity (tecla M) — toggle.
  useEffect(() => {
    function handleOpenJavamons() {
      setShowJavamons((prev) => {
        if (prev) {
          if (isLoaded && unityProvider) {
            sendMessage("MultiplayerManager", "UnpauseGame");
          }
          return false;
        }
        setLoadingJavamons(true);
        if (isLoaded && unityProvider) {
          sendMessage("MultiplayerManager", "PauseGame");
        }
        return true;
      });
    }
    addEventListener("OpenJavamons", handleOpenJavamons);
    return () => {
      removeEventListener("OpenJavamons", handleOpenJavamons);
    };
  }, [addEventListener, removeEventListener, isLoaded, unityProvider, sendMessage]);

  // Listener para abrir el visor de Actividad (Show Activity Data) desde Unity
  useEffect(() => {
    async function handleOpenActivityData(payloadJson: any) {
      try {
        let actId = "";
        if (typeof payloadJson === "string") {
          const parsed = JSON.parse(payloadJson || "{}");
          actId = parsed.activityId || "";
        } else if (payloadJson && payloadJson.activityId) {
          actId = payloadJson.activityId;
        }

        // Si no vino id de actividad, buscar las actividades del aula actual o del usuario
        if (!actId) {
          const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost';
          const token = localStorage.getItem('authToken');
          const res = await fetch(`${baseUrl}:8061/usuaris/${userId}/jutge/activitats`, {
            headers: token ? { 'Authorization': `Bearer ${token}` } : {}
          });
          if (res.ok) {
            const list = await res.json();
            if (Array.isArray(list) && list.length > 0) {
              actId = String(list[0].id);
            }
          }
        }

        if (actId) {
          setActiveActivityId(actId);
          setLoadingActivity(true);
          setShowActivityModal(true);
          if (isLoaded && unityProvider) {
            sendMessage("MultiplayerManager", "PauseGame");
          }
        }
      } catch (err) {
        console.error("[ZeldaUnityGame] Error al procesar OpenActivityData:", err);
      }
    }

    addEventListener("OpenActivityData", handleOpenActivityData);
    return () => {
      removeEventListener("OpenActivityData", handleOpenActivityData);
    };
  }, [addEventListener, removeEventListener, isLoaded, unityProvider, sendMessage, userId]);

  // Listener para abrir el selector de Actividades desde Unity (InteractActionType.SelectActivity)
  useEffect(() => {
    function handleOpenSelectActivity() {
      setLoadingActivitiesModal(true);
      setShowActivitiesModal(true);
      if (isLoaded && unityProvider) {
        sendMessage("MultiplayerManager", "PauseGame");
      }
    }

    addEventListener("OpenSelectActivity", handleOpenSelectActivity);
    return () => {
      removeEventListener("OpenSelectActivity", handleOpenSelectActivity);
    };
  }, [addEventListener, removeEventListener, isLoaded, unityProvider, sendMessage]);

  // Cierra el iframe de captura manualmente (botón X o Escape): se interpreta como
  // ESCAPE del javamon. Avisamos a Unity (CaptureBridge) para volver inmediatamente al pueblo.
  const closeCapture = React.useCallback(() => {
    if (isLoaded && unityProvider) {
      sendMessage("CaptureBridge", "OnCaptureDone", JSON.stringify({ success: false }));
    }
    setCaptureUrl(null);
  }, [isLoaded, unityProvider, sendMessage]);

  // Cierra el IDE Theia (iframe grande): notifica cierre de intento, pausa el contenedor
  // Docker y reanuda el juego. Se usa tanto desde el botón de cerrar como desde Escape.
  const closeTheiaIde = React.useCallback(() => {
    if (userId && activeExercise) {
      try {
        const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost';
        const token = localStorage.getItem('authToken');
        const payload = JSON.stringify({
          id_problema: activeExercise.problemaId + '',
          id_activitat: activeExercise.actividadId ? activeExercise.actividadId + '' : '',
          id_usuari: userId + ''
        });
        if (navigator.sendBeacon) {
          navigator.sendBeacon(`${baseUrl}:8061/jutge/enviament/close-attempt`, new Blob([payload], { type: 'application/json' }));
        } else {
          fetch(`${baseUrl}:8061/jutge/enviament/close-attempt`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
            body: payload,
            keepalive: true
          }).catch(() => { });
        }
      } catch (e) {
        console.warn('[ZeldaUnityGame] Error al cerrar intento:', e);
      }
    }
    setIframeUrl(null);
    setActiveExercise(null);
    if (isLoaded && unityProvider) {
      sendMessage("MultiplayerManager", "UnpauseGame");
    }
  }, [userId, activeExercise, isLoaded, unityProvider, sendMessage]);

  // Listener para abrir el iframe de CAPTURA (opción B) cuando el javamon enemigo es derrotado.
  // Unity (CaptureBridge) envía los datos del javamon; mostramos las JAVAballs en el iframe.
  useEffect(() => {
    function handleOpenCaptureUI(payloadJson: any) {
      try {
        const data = typeof payloadJson === "string" ? JSON.parse(payloadJson || "{}") : (payloadJson || {});
        const javamonId = data.javamonId ?? "";
        const javamonNom = data.javamonNom ?? "";
        const javamonImg = data.javamonImg ?? "";
        const url = `${window.location.origin}/game/capture?javamonId=${encodeURIComponent(javamonId)}&javamonNom=${encodeURIComponent(javamonNom)}&javamonImg=${encodeURIComponent(javamonImg)}`;
        setLoadingCapture(true);
        setCaptureUrl(url);
        if (isLoaded && unityProvider) {
          sendMessage("MultiplayerManager", "PauseGame");
        }
      } catch (e) {
        console.error("[ZeldaUnityGame] Error procesando OpenCaptureUI:", e);
      }
    }

    addEventListener("OpenCaptureUI", handleOpenCaptureUI);
    return () => {
      removeEventListener("OpenCaptureUI", handleOpenCaptureUI);
    };
  }, [addEventListener, removeEventListener, isLoaded, unityProvider, sendMessage]);

  // Listener para el MENÚ DE PAUSA (tecla Escape en Unity). Unity ya pausó el juego y
  // nos pide mostrar el menú como modal React.
  // Guard temporal: tras cerrar el menú (Escape/✕) ignoramos durante un breve lapso
  // un nuevo OpenGameMenu, porque Unity también procesa el mismo Escape y, si no,
  // reabriría el menú justo después de cerrarlo.
  // Listener para el MENÚ DE PAUSA (tecla Escape en Unity).
  const gameMenuClosedAtRef = React.useRef<number>(0);
  useEffect(() => {
    function handleOpenGameMenu() {
      // Si el menú se cerró hace menos de 400ms, ignoramos el evento OpenGameMenu para que
      // pulsar Escape dos veces no lo vuelva a abrir instantáneamente.
      if (Date.now() - gameMenuClosedAtRef.current < 400) {
        return;
      }
      setShowGameMenu(true);
    }
    function handleCloseGameMenu() {
      gameMenuClosedAtRef.current = Date.now();
      setShowGameMenu(false);
    }
    addEventListener("OpenGameMenu", handleOpenGameMenu);
    addEventListener("CloseGameMenu", handleCloseGameMenu);
    return () => {
      removeEventListener("OpenGameMenu", handleOpenGameMenu);
      removeEventListener("CloseGameMenu", handleCloseGameMenu);
    };
  }, [addEventListener, removeEventListener]);

  // Listener: abrir el modal de recompensa YA en estado "cargando" (spinner dentro del iframe)
  // mientras Unity/backend resuelven las recompensas del cofre.
  useEffect(() => {
    function handleShowRewardModalLoading() {
      setRecompensaItems([]);
      setRecompensaStatus("ok");
      setRecompensaEmptyReason(undefined);
      setRecompensaMessage(undefined);
      setRecompensaLoading(true);
      setRecompensaModalVisible(true);
      if (isLoaded && unityProvider) {
        sendMessage("MultiplayerManager", "PauseGame");
      }
    }
    addEventListener("ShowRewardModalLoading", handleShowRewardModalLoading);
    return () => {
      removeEventListener("ShowRewardModalLoading", handleShowRewardModalLoading);
    };
  }, [addEventListener, removeEventListener, isLoaded, unityProvider, sendMessage]);

  // Listener para mostrar el modal de recompensa (popup de botín idéntico a ActivitatsIdExercicis)
  useEffect(() => {
    function handleShowRewardModal(payload: any) {
      try {
        console.log("[ZeldaUnityGame] Recibido ShowRewardModal desde Unity:", payload);
        const data = typeof payload === "string" ? JSON.parse(payload) : payload;
        const items = data?.claimed || (Array.isArray(data) ? data : []);

        // Botín sin recompensas disponibles (ya reclamado o agotado):
        // Mostramos el modal explicando exactamente que la recompensa ha sido agotada o ya reclamada.
        if (data?.status === "empty" || (items.length === 0 && !Array.isArray(data))) {
          setRecompensaItems([]);
          setRecompensaStatus("empty");
          setRecompensaEmptyReason(data?.reason);
          setRecompensaMessage(data?.message);
          setRecompensaLoading(false);
          setRecompensaModalVisible(true);
          if (isLoaded && unityProvider) {
            sendMessage("MultiplayerManager", "PauseGame");
          }
          return;
        }

        setRecompensaItems(items);
        setRecompensaStatus("ok");
        setRecompensaEmptyReason(undefined);
        setRecompensaMessage(undefined);
        setRecompensaSelectableMode(false);
        setRecompensaSelectionOptions([]);
        setRecompensaGuaranteedRewards([]);
        setRecompensaPendingChestData(null);
        setRecompensaLoading(false);
        setRecompensaModalVisible(true);
        if (isLoaded && unityProvider) {
          sendMessage("MultiplayerManager", "PauseGame");
        }
      } catch (err) {
        console.error("[ZeldaUnityGame] Error procesando ShowRewardModal:", err);
      }
    }

    addEventListener("ShowRewardModal", handleShowRewardModal);
    return () => {
      removeEventListener("ShowRewardModal", handleShowRewardModal);
    };
  }, [addEventListener, removeEventListener, isLoaded, unityProvider, sendMessage]);

  // Listener para mostrar el modal de recompensa en MODO SELECCIONABLE (grupo_seleccion > 0)
  useEffect(() => {
    function handleShowRewardModalSelectable(payload: any) {
      try {
        console.log("[ZeldaUnityGame] Recibido ShowRewardModalSelectable desde Unity:", payload);
        const data = typeof payload === "string" ? JSON.parse(payload) : payload;
        // data: { id_actividad, id_problema, id_usuari, interactableId, options: [...], guaranteed: [...] }
        console.log("[ZeldaUnityGame] Opciones de selección para el cofre:", data);
        setRecompensaPendingChestData(data);
        setRecompensaSelectionOptions(data.options || []);
        setRecompensaGuaranteedRewards(data.guaranteed || []);
        setRecompensaSelectableMode(true);
        setRecompensaItems([]);
        setRecompensaStatus("ok");
        setRecompensaEmptyReason(undefined);
        setRecompensaMessage(undefined);
        setRecompensaLoading(false);
        setRecompensaModalVisible(true);
        if (isLoaded && unityProvider) {
          sendMessage("MultiplayerManager", "PauseGame");
        }
      } catch (err) {
        console.error("[ZeldaUnityGame] Error procesando ShowRewardModalSelectable:", err);
      }
    }

    addEventListener("ShowRewardModalSelectable", handleShowRewardModalSelectable);
    return () => {
      removeEventListener("ShowRewardModalSelectable", handleShowRewardModalSelectable);
    };
  }, [addEventListener, removeEventListener, isLoaded, unityProvider, sendMessage]);

  // Listener para mostrar el modal de DERROTA en el battleground
  useEffect(() => {
    function handleShowDefeatModal(payload: any) {
      try {
        console.log("[ZeldaUnityGame] Recibido ShowDefeatModal desde Unity:", payload);
        const data = typeof payload === "string" ? JSON.parse(payload || "{}") : (payload || {});
        setDefeatReason(data?.reason || "Has sido derrotado en combate.");
        setShowDefeatModal(true);
        if (isLoaded && unityProvider) {
          sendMessage("MultiplayerManager", "PauseGame");
        }
      } catch (err) {
        console.error("[ZeldaUnityGame] Error procesando ShowDefeatModal:", err);
      }
    }

    addEventListener("ShowDefeatModal", handleShowDefeatModal);
    return () => {
      removeEventListener("ShowDefeatModal", handleShowDefeatModal);
    };
  }, [addEventListener, removeEventListener, isLoaded, unityProvider, sendMessage]);

  // Listener para el modal de SANTUARIO con barra de progreso
  useEffect(() => {
    function handleShowSanctuary(payload: any) {
      try {
        console.log("[ZeldaUnityGame] Recibido ShowSanctuaryModal desde Unity:", payload);
        const data = typeof payload === "string" ? JSON.parse(payload || "{}") : (payload || {});
        const hearts = Number(data?.heartsToRecover) || 1;
        const totalSec = Number(data?.totalSeconds) || hearts * 30;
        const curHp = Number(data?.currentHp) || 1;
        const maxHp = Number(data?.maxHp) || 3;

        setSanctuaryData({ heartsToRecover: hearts, totalSeconds: totalSec, currentHp: curHp, maxHp });
        setSanctuaryProgress(0);
        setSanctuarySecondsLeft(Math.ceil(totalSec));
        setShowSanctuaryModal(true);
      } catch (err) {
        console.error("[ZeldaUnityGame] Error procesando ShowSanctuaryModal:", err);
      }
    }

    function handleCloseSanctuary() {
      setShowSanctuaryModal(false);
    }

    addEventListener("ShowSanctuaryModal", handleShowSanctuary);
    addEventListener("CloseSanctuaryModal", handleCloseSanctuary);
    return () => {
      removeEventListener("ShowSanctuaryModal", handleShowSanctuary);
      removeEventListener("CloseSanctuaryModal", handleCloseSanctuary);
    };
  }, [addEventListener, removeEventListener]);

  // Listener para el modal de DESBLOQUEO POR CÓDIGO (interactuable LootConCodigo).
  // Unity abre el modal; React recoge el código y lo envía a MultiplayerManager.SubmitUnlockCode.
  // Unity valida: si acierta envía CloseCodeUnlock (cerramos); si falla envía CodeUnlockError.
  useEffect(() => {
    function handleOpenCodeUnlock() {
      setCodeUnlockValue("");
      setCodeUnlockError("");
      setCodeUnlockSubmitting(false);
      setShowCodeUnlock(true);
      // Unity ya pausa el juego (PauseGame) antes de abrir el modal.
    }
    function handleCloseCodeUnlock() {
      setShowCodeUnlock(false);
      setCodeUnlockValue("");
      setCodeUnlockError("");
      setCodeUnlockSubmitting(false);
      // El movimiento lo reanuda Unity (UnpauseGame) tras un código correcto.
    }
    function handleCodeUnlockError(payload: any) {
      try {
        const data = typeof payload === "string" ? JSON.parse(payload || "{}") : (payload || {});
        setCodeUnlockError(data?.message || "Código incorrecto. Inténtalo de nuevo.");
      } catch {
        setCodeUnlockError("Código incorrecto. Inténtalo de nuevo.");
      }
      setCodeUnlockSubmitting(false);
    }
    addEventListener("OpenCodeUnlock", handleOpenCodeUnlock);
    addEventListener("CloseCodeUnlock", handleCloseCodeUnlock);
    addEventListener("CodeUnlockError", handleCodeUnlockError);
    return () => {
      removeEventListener("OpenCodeUnlock", handleOpenCodeUnlock);
      removeEventListener("CloseCodeUnlock", handleCloseCodeUnlock);
      removeEventListener("CodeUnlockError", handleCodeUnlockError);
    };
  }, [addEventListener, removeEventListener]);

  // Temporizador para actualizar la barra de progreso del santuario
  useEffect(() => {
    if (!showSanctuaryModal || sanctuaryData.totalSeconds <= 0) return;

    const start = Date.now();
    const durationMs = sanctuaryData.totalSeconds * 1000;

    const interval = setInterval(() => {
      const elapsed = Date.now() - start;
      const pct = Math.min(100, (elapsed / durationMs) * 100);
      const remaining = Math.max(0, Math.ceil((durationMs - elapsed) / 1000));

      setSanctuaryProgress(pct);
      setSanctuarySecondsLeft(remaining);

      if (pct >= 100) {
        clearInterval(interval);
        setTimeout(() => {
          setShowSanctuaryModal(false);
          // Garantizar que Unity desbloquee al jugador aunque su temporizador vaya desfasado
          if (isLoaded && unityProvider) {
            try { sendMessage("MultiplayerManager", "OnSanctuaryModalClosed"); } catch (e) {}
          }
        }, 800);
      }
    }, 100);

    return () => clearInterval(interval);
  }, [showSanctuaryModal, sanctuaryData]);

  // Listener para recibir mensajes desde los iframes secundarios (ej. teletransporte de escena, inventario, cierre del panel Theia)
  useEffect(() => {
    const handleWindowMessage = (event: MessageEvent) => {
      if (event.data?.type === "TELEPORT_SCENE" && event.data.scene) {
        const sceneName = String(event.data.scene).trim();
        const activityId = event.data.activityId != null ? String(event.data.activityId) : "";
        console.log("[ZeldaUnityGame] Recibido TELEPORT_SCENE a:", sceneName, "actividad:", activityId);
        setShowActivitiesModal(false);
        if (isLoaded && unityProvider) {
          // Enviamos escena + actividad elegida como JSON para que Unity cargue los
          // ejercicios de ESA actividad (y no los de otra que comparta escena+aula).
          const payload = JSON.stringify({ scene: sceneName, activityId });
          sendMessage("MultiplayerManager", "TeleportToScene", payload);
        }
      } else if (event.data?.type === "REFRESH_PLAYER_EQUIPMENT") {
        console.log("[ZeldaUnityGame] Recibido REFRESH_PLAYER_EQUIPMENT desde iframe de inventario");
        if (isLoaded && unityProvider) {
          sendMessage("LoginManagerGO", "RefreshPlayerData", "");
        }
      } else if (event.data?.type === "SPAWN_JAVAMON_PET") {
        // El iframe de Javamons pide invocar un javamon como mascota al lado del jugador.
        const prefabName = String(event.data.prefabName || "").trim();
        if (prefabName && isLoaded && unityProvider) {
          sendMessage("LoginManagerGO", "SpawnJavamonPetByName", prefabName);
        }
      } else if (event.data?.type === "THEIA_PANEL_CLOSE") {
        // El panel de ejercicio (TheiaGamePanel) ha sido cerrado por el usuario
        console.log("[ZeldaUnityGame] Recibido THEIA_PANEL_CLOSE desde TheiaGamePanel");
        const exercise = event.data?.activeExercise ?? null;
        if (exercise && userId) {
          // Notificar cierre de intento (close-attempt)
          try {
            const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost';
            const token = localStorage.getItem('authToken');
            const payload = JSON.stringify({
              id_problema: exercise.problemaId + '',
              id_activitat: exercise.actividadId ? exercise.actividadId + '' : '',
              id_usuari: userId + ''
            });
            if (navigator.sendBeacon) {
              navigator.sendBeacon(`${baseUrl}:8061/jutge/enviament/close-attempt`, new Blob([payload], { type: 'application/json' }));
            } else {
              fetch(`${baseUrl}:8061/jutge/enviament/close-attempt`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': token ? `Bearer ${token}` : '' },
                body: payload,
                keepalive: true
              }).catch(() => { });
            }
          } catch (e) {
            console.warn('[ZeldaUnityGame] Error al cerrar intento:', e);
          }
        }
        setIframeUrl(null);
        setActiveExercise(null);
        if (isLoaded && unityProvider) {
          sendMessage("MultiplayerManager", "UnpauseGame");
        }
      } else if (event.data?.type === "THEIA_PANEL_OPEN_IDE" && event.data.url) {
        console.log("[ZeldaUnityGame] Recibido THEIA_PANEL_OPEN_IDE, cambiando iframeUrl a:", event.data.url);
        // Establecer cargando para que no se vea el panel web estirándose mientras carga el nuevo IDE
        setLoadingTheia(true);
        setPanelExpanded(false);
        setIframeUrl(event.data.url);
      } else if (event.data?.type === "THEIA_PANEL_EXPAND") {
        // El panel del juego abrió un sub-modal (enunciado / código): agrandar el iframe.
        setPanelExpanded(true);
      } else if (event.data?.type === "THEIA_PANEL_COLLAPSE") {
        // Se cerró el sub-modal: volver al tamaño compacto del panel.
        setPanelExpanded(false);
      } else if (event.data?.type === "CAPTURE_THROW") {
        // El iframe de captura ha lanzado una JAVAball; Unity reproduce la animación con el
        // resultado real (capturado/escapado).
        if (isLoaded && unityProvider) {
          sendMessage("CaptureBridge", "OnCaptureThrow", JSON.stringify(event.data));
        }
      } else if (event.data?.type === "CAPTURE_DONE") {
        // Fin de la captura: cerrar el iframe y avisar a Unity para volver al pueblo.
        if (isLoaded && unityProvider) {
          sendMessage("CaptureBridge", "OnCaptureDone", JSON.stringify(event.data));
        }
        setCaptureUrl(null);
      }
    };

    window.addEventListener("message", handleWindowMessage);
    return () => {
      window.removeEventListener("message", handleWindowMessage);
    };
  }, [isLoaded, unityProvider, sendMessage, userId]);

  // Cerrar modales (Javashop, Inventario, Javadex, Actividad, Actividades) con la tecla Escape
  useEffect(() => {
    if (!showJavashop && !showInventory && !showJavadex && !showMochila && !showJavamons && !showActivityModal && !showActivitiesModal) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        // Si el iframe de captura está abierto, NO cerramos aquí (lo gestiona su propio
        // listener como "escape del javamon"); evitamos además reanudar el juego por error.
        if (captureUrl) return;
        const wasInventoryOpen = showInventory;
        if (showJavashop) setShowJavashop(false);
        if (showInventory) setShowInventory(false);
        if (showJavadex) setShowJavadex(false);
        if (showMochila) setShowMochila(false);
        if (showJavamons) setShowJavamons(false);
        if (showActivityModal) setShowActivityModal(false);
        if (showActivitiesModal) setShowActivitiesModal(false);
        if (isLoaded && unityProvider) {
          if (wasInventoryOpen) {
            sendMessage("LoginManagerGO", "RefreshPlayerData", "");
          }
          sendMessage("MultiplayerManager", "UnpauseGame");
        }
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [showJavashop, showInventory, showJavadex, showMochila, showJavamons, showActivityModal, showActivitiesModal, isLoaded, unityProvider, sendMessage, captureUrl]);

  // Escape en el iframe de captura: se interpreta como escape del javamon y cierra el iframe.
  useEffect(() => {
    if (!captureUrl) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        e.preventDefault();
        closeCapture();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [captureUrl, closeCapture]);

  // Escape en el menú de pausa React: lo cierra y reanuda el juego.
  useEffect(() => {
    if (!showGameMenu) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        e.preventDefault();
        gameMenuClosedAtRef.current = Date.now(); // evita que Unity lo reabra con el mismo Escape
        setShowGameMenu(false);
        if (isLoaded && unityProvider) {
          sendMessage("MultiplayerManager", "UnpauseGame");
          try { sendMessage("LoginManagerGO", "UnpauseGame"); } catch (e) {}
        }
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [showGameMenu, isLoaded, unityProvider, sendMessage]);

  // Escape en el modal de derrota: confirma la derrota y vuelve al pueblo.
  useEffect(() => {
    if (!showDefeatModal) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        e.preventDefault();
        setShowDefeatModal(false);
        if (isLoaded && unityProvider) {
          try { sendMessage("LoginManagerGO", "OnDefeatConfirmed"); } catch (err) {}
          try { sendMessage("Character", "OnDefeatConfirmed"); } catch (err) {}
        }
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [showDefeatModal, isLoaded, unityProvider, sendMessage]);

  // Enviar el código introducido a Unity para que lo valide y entregue el botín.
  const submitUnlockCode = React.useCallback(() => {
    const code = codeUnlockValue.trim();
    if (!code) {
      setCodeUnlockError("Escribe un código.");
      return;
    }
    setCodeUnlockError("");
    setCodeUnlockSubmitting(true);
    if (isLoaded && unityProvider) {
      sendMessage("MultiplayerManager", "SubmitUnlockCode", code);
    }
  }, [codeUnlockValue, isLoaded, unityProvider, sendMessage]);

  // Cancelar/cerrar el modal de código: avisamos a Unity para reanudar el juego.
  const cancelUnlockCode = React.useCallback(() => {
    setShowCodeUnlock(false);
    setCodeUnlockValue("");
    setCodeUnlockError("");
    setCodeUnlockSubmitting(false);
    if (isLoaded && unityProvider) {
      sendMessage("MultiplayerManager", "CancelUnlockCode", "");
    }
  }, [isLoaded, unityProvider, sendMessage]);

  // Escape cierra el modal de código (equivale a cancelar).
  useEffect(() => {
    if (!showCodeUnlock) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        e.preventDefault();
        cancelUnlockCode();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [showCodeUnlock, cancelUnlockCode]);

  const loadingPercentage = Math.round(loadingProgression * 100);

  return (
    <div style={{
      position: "fixed",
      top: 0, left: 0,
      width: "100vw",
      height: "100vh",
      background: "#000",
      zIndex: 9999,
    }}>
      <style>
        {`
          @keyframes spinIframe {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>

      {/* Pantalla de carga */}
      {!isLoaded && (
        <div style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          background: "#111",
          color: "#fff",
          zIndex: 1,
          gap: 16,
        }}>
          <p style={{ fontSize: 20, margin: 0 }}>Cargando el juego... {loadingPercentage}%</p>
          <div style={{
            width: 300,
            height: 8,
            background: "#333",
            borderRadius: 4,
            overflow: "hidden",
          }}>
            <div style={{
              width: `${loadingPercentage}%`,
              height: "100%",
              background: "linear-gradient(90deg, #667eea, #764ba2)",
              transition: "width 0.3s ease",
            }} />
          </div>
        </div>
      )}

      {/* Canvas de Unity a pantalla completa */}
      <Unity
        unityProvider={unityProvider}
        devicePixelRatio={window.devicePixelRatio}
        style={{
          width: "100%",
          height: "100%",
          visibility: isLoaded ? "visible" : "hidden",
          display: "block",
        }}
      />

      {/* Panel del juego (tarjeta flotante propia de TheiaGamePanel) - sin marco RPG
          porque ya es una tarjeta con su propio estilo y botones "Salir". */}
      {iframeUrl && iframeUrl.includes("theia-panel") && (
        <div style={
          !panelExpanded
            ? {
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "420px",
              height: "250px", // Fixed height because iframe with auto collapses
              background: "transparent",
              zIndex: 10,
              display: "flex",
              flexDirection: "column",
              borderRadius: "14px",
              overflow: "hidden"
            }
            : {
              // Panel del juego AGRANDADO (al abrir enunciado / código enviado)
              position: "absolute",
              inset: "20px",
              background: "transparent",
              zIndex: 10,
              display: "flex",
              flexDirection: "column",
              borderRadius: "14px",
              overflow: "hidden"
            }
        }>
          <div style={{ position: "relative", flex: 1, width: "100%", height: "100%" }}>
            {loadingTheia && (
              <div style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                background: "#f8f9fb",
                color: "#333",
                zIndex: 10,
                borderRadius: "14px"
              }}>
                <div style={{
                  width: "48px",
                  height: "48px",
                  border: "4px solid rgba(24, 144, 255, 0.2)",
                  borderTop: "4px solid #1890ff",
                  borderRadius: "50%",
                  animation: "spinIframe 1s linear infinite"
                }} />
                <p style={{ marginTop: 16, fontSize: "15px", fontWeight: 600, color: "#555" }}>
                  Cargando información...
                </p>
              </div>
            )}
            <iframe
              src={iframeUrl}
              onLoad={() => setLoadingTheia(false)}
              style={{ width: "100%", height: "100%", border: "none" }}
              title="Panel del ejercicio"
            />
          </div>
        </div>
      )}

      {/* IDE Theia (editor VS Code) - marco RPG grande con cabecera y cerrar. */}
      {iframeUrl && !iframeUrl.includes("theia-panel") && (
        <GameModalFrame
          title="Desafío IDE"
          icon="💻"
          accent="#1f6f6f"
          size="full"
          zIndex={10}
          loading={loadingTheia}
          loadingText="Cargando entorno de desarrollo Theia..."
          onClose={closeTheiaIde}
        >
          <iframe
            src={iframeUrl}
            onLoad={() => setLoadingTheia(false)}
            style={{ width: "100%", height: "100%", border: "none", background: "#1e1e1e" }}
            title="Theia IDE"
          />
        </GameModalFrame>
      )}

      {/* Iframe Modal for Javashop */}
      {showJavashop && (
        <GameModalFrame
          title="JAVATienda"
          icon="🛒"
          accent="#531dab"
          size="lg"
          loading={loadingShop}
          loadingText="Cargando JAVATienda..."
          onClose={() => {
            setShowJavashop(false);
            if (isLoaded && unityProvider) {
              sendMessage("MultiplayerManager", "UnpauseGame");
            }
          }}
        >
          <iframe
            src={`${window.location.origin}/game/javashop`}
            sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
            onLoad={() => setLoadingShop(false)}
            style={{ width: "100%", height: "100%", border: "none" }}
            title="JAVATienda"
          />
        </GameModalFrame>
      )}

      {/* Iframe Modal for Inventory (Equipamiento RPG) */}
      {showInventory && (
        <GameModalFrame
          title="Equipamiento RPG"
          icon="🛡️"
          accent="#5a3f7a"
          size="lg"
          loading={loadingInventory}
          loadingText="Cargando Equipamiento RPG..."
          onClose={() => {
            setShowInventory(false);
            if (isLoaded && unityProvider) {
              sendMessage("LoginManagerGO", "RefreshPlayerData", "");
              sendMessage("MultiplayerManager", "UnpauseGame");
            }
          }}
        >
          <iframe
            src={`${window.location.origin}/game/equipment`}
            sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
            onLoad={() => setLoadingInventory(false)}
            style={{ width: "100%", height: "100%", border: "none" }}
            title="Equipamiento RPG"
          />
        </GameModalFrame>
      )}

      {/* Iframe Modal for JAVAdex */}
      {showJavadex && (
        <GameModalFrame
          title="JAVAdex"
          icon="📖"
          accent="#1769aa"
          size="lg"
          loading={loadingJavadex}
          loadingText="Cargando JAVAdex..."
          onClose={() => {
            setShowJavadex(false);
            if (isLoaded && unityProvider) {
              sendMessage("MultiplayerManager", "UnpauseGame");
            }
          }}
        >
          <iframe
            src={`${window.location.origin}/game/javadex`}
            sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
            onLoad={() => setLoadingJavadex(false)}
            style={{ width: "100%", height: "100%", border: "none" }}
            title="JAVAdex"
          />
        </GameModalFrame>
      )}

      {/* Iframe Modal RPG for Mochila (tecla N) - panel centrado, no pantalla completa */}
      {showMochila && (
        <GameModalFrame
          title="Mochila"
          icon="🎒"
          size="md"
          loading={loadingMochila}
          onClose={() => {
            setShowMochila(false);
            if (isLoaded && unityProvider) {
              sendMessage("MultiplayerManager", "UnpauseGame");
            }
          }}
        >
          <iframe
            src={`${window.location.origin}/game/mochila`}
            sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
            onLoad={() => setLoadingMochila(false)}
            style={{ width: "100%", height: "100%", border: "none" }}
            title="Mochila"
          />
        </GameModalFrame>
      )}

      {/* Iframe Modal RPG for Javamons (tecla M) - panel centrado, no pantalla completa */}
      {showJavamons && (
        <GameModalFrame
          title="Javamons"
          icon="🐾"
          accent="#2b5e4a"
          size="md"
          loading={loadingJavamons}
          onClose={() => {
            setShowJavamons(false);
            if (isLoaded && unityProvider) {
              sendMessage("MultiplayerManager", "UnpauseGame");
            }
          }}
        >
          <iframe
            src={`${window.location.origin}/game/javamons`}
            sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
            onLoad={() => setLoadingJavamons(false)}
            style={{ width: "100%", height: "100%", border: "none" }}
            title="Javamons"
          />
        </GameModalFrame>
      )}

      {/* Iframe Modal for Activity Data (Show Activity Data) */}
      {showActivityModal && activeActivityId && (
        <GameModalFrame
          title="Desafíos y Progreso de la Actividad"
          icon="⚔️"
          accent="#9e2a1a"
          size="lg"
          loading={loadingActivity}
          loadingText="Cargando datos de la actividad..."
          onClose={() => {
            setShowActivityModal(false);
            if (isLoaded && unityProvider) {
              sendMessage("MultiplayerManager", "UnpauseGame");
            }
          }}
        >
          <iframe
            src={`${window.location.origin}/game/activity/${activeActivityId}`}
            sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
            onLoad={() => setLoadingActivity(false)}
            style={{ width: "100%", height: "100%", border: "none" }}
            title="Progreso de Actividad"
          />
        </GameModalFrame>
      )}

      {/* Iframe Modal for Activities Selection (Activitats) */}
      {showActivitiesModal && (
        <GameModalFrame
          title="Selección de Actividades y Módulos"
          icon="🗺️"
          accent="#3f7a2b"
          size="lg"
          loading={loadingActivitiesModal}
          loadingText="Cargando catálogo de actividades..."
          onClose={() => {
            setShowActivitiesModal(false);
            if (isLoaded && unityProvider) {
              sendMessage("MultiplayerManager", "UnpauseGame");
            }
          }}
        >
          <iframe
            src={`${window.location.origin}/game/activities`}
            sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
            onLoad={() => setLoadingActivitiesModal(false)}
            style={{ width: "100%", height: "100%", border: "none" }}
            title="Selección de Actividades"
          />
        </GameModalFrame>
      )}

      {/* Iframe de CAPTURA (opción B) - panel centrado estilo RPG. Cerrar = el JAVAmon escapa. */}
      {captureUrl && (
        <GameModalFrame
          title="Captura JAVAmon"
          icon="🎯"
          size="md"
          zIndex={30}
          loading={loadingCapture}
          closeHint="Cerrar (el JAVAmon escapará)"
          onClose={() => closeCapture()}
        >
          <iframe
            src={captureUrl}
            sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
            onLoad={() => setLoadingCapture(false)}
            style={{ width: "100%", height: "100%", border: "none" }}
            title="Captura JAVAmon"
          />
        </GameModalFrame>
      )}

      {/* MENÚ DE PAUSA (Escape) como modal React con estética RPG. */}
      {showGameMenu && (
        <GameModalFrame
          title="Menú de Pausa"
          icon="⏸️"
          size="pauseMenu"
          zIndex={40}
          flush={false}
          onClose={() => {
            gameMenuClosedAtRef.current = Date.now();
            setShowGameMenu(false);
            if (isLoaded && unityProvider) {
              sendMessage("MultiplayerManager", "UnpauseGame");
              try { sendMessage("LoginManagerGO", "UnpauseGame"); } catch (e) {}
            }
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: 10, height: "100%", justifyContent: "center" }}>
            {([
              { label: "Inventario (I)", icon: "🛡️", open: () => { setLoadingInventory(true); setShowInventory(true); } },
              { label: "Mochila (N)", icon: "🎒", open: () => { setLoadingMochila(true); setShowMochila(true); } },
              { label: "Javamons (M)", icon: "🐾", open: () => { setLoadingJavamons(true); setShowJavamons(true); } },
              { label: "JAVAdex (P)", icon: "📖", open: () => { setLoadingJavadex(true); setShowJavadex(true); } },
            ] as const).map((opt) => (
              <button
                key={opt.label}
                onClick={() => {
                  // Cerramos el menú y abrimos el panel elegido (el juego sigue en pausa).
                  setShowGameMenu(false);
                  opt.open();
                }}
                style={{
                  display: "flex", alignItems: "center", gap: 10,
                  background: "linear-gradient(90deg, #5a4328 0%, #7a5c38 100%)",
                  border: "2px solid #c79a5c", color: "#f5e9d6",
                  fontWeight: 700, fontSize: 15, padding: "11px 16px",
                  borderRadius: 10, cursor: "pointer", textShadow: "0 1px 0 rgba(0,0,0,0.4)",
                  transition: "transform 0.08s, filter 0.1s",
                }}
                onMouseEnter={(e) => { e.currentTarget.style.transform = "scale(1.02)"; e.currentTarget.style.filter = "brightness(1.12)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = "scale(1)"; e.currentTarget.style.filter = "brightness(1)"; }}
              >
                <span style={{ fontSize: 18 }}>{opt.icon}</span>{opt.label}
              </button>
            ))}

            <button
              onClick={() => {
                // Logout: avisamos a Unity para que desconecte y muestre el mensaje de salida.
                setShowGameMenu(false);
                if (isLoaded && unityProvider) {
                  sendMessage("LoginManagerGO", "LogoutFromMenu", "");
                }
              }}
              style={{
                display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
                background: "linear-gradient(90deg, #7a2b1a 0%, #a53b2b 100%)",
                border: "2px solid #d98a6c", color: "#fff4e0",
                fontWeight: 700, fontSize: 15, padding: "11px 16px",
                borderRadius: 10, cursor: "pointer", marginTop: 4,
                textShadow: "0 1px 0 rgba(0,0,0,0.4)",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.filter = "brightness(1.12)"; }}
              onMouseLeave={(e) => { e.currentTarget.style.filter = "brightness(1)"; }}
            >
              🚪 Salir del juego (Logout)
            </button>
          </div>
        </GameModalFrame>
      )}

      {/* Modal de Recompensa (idéntico al de ActivitatsIdExercicis) */}
      {recompensaModalVisible && (
        <RecompensaSummaryModal
          visible={recompensaModalVisible}
          loading={recompensaLoading}
          status={recompensaStatus}
          emptyReason={recompensaEmptyReason}
          message={recompensaMessage}
          selectableMode={recompensaSelectableMode}
          selectionOptions={recompensaSelectionOptions}
          guaranteedRewards={recompensaGuaranteedRewards}
          onConfirmSelection={(item: any) => {
            // El usuario ha elegido una de las recompensas agrupadas:
            // Ponemos el modal en estado 'cargando' mientras Unity y el backend procesan el claim
            setRecompensaSelectableMode(false);
            setRecompensaSelectionOptions([]);
            setRecompensaGuaranteedRewards([]);
            setRecompensaLoading(true);

            if (isLoaded && unityProvider) {
              sendMessage("MultiplayerManager", "OnRewardSelected", String(item.id));
            }
          }}
          onClose={() => {
            // Mientras carga no se puede cerrar (evita cerrar el iframe antes de ver las recompensas).
            if (recompensaLoading) return;
            setRecompensaSelectableMode(false);
            setRecompensaSelectionOptions([]);
            setRecompensaGuaranteedRewards([]);
            setRecompensaPendingChestData(null);
            setRecompensaModalVisible(false);
            if (isLoaded && unityProvider) {
              sendMessage("MultiplayerManager", "UnpauseGame");
              sendMessage("MultiplayerManager", "OnRewardModalClosed");
            }
          }}
          rewards={recompensaItems}
        />
      )}

      {/* Modal RPG de DERROTA en el Battleground */}
      {showDefeatModal && (
        <GameModalFrame
          title="Derrota en Combate"
          icon="💀"
          accent="#8a2020"
          size="sm"
          zIndex={50}
          flush={false}
          onClose={() => {
            setShowDefeatModal(false);
            if (isLoaded && unityProvider) {
              try { sendMessage("LoginManagerGO", "OnDefeatConfirmed"); } catch (err) {}
              try { sendMessage("Character", "OnDefeatConfirmed"); } catch (err) {}
            }
          }}
        >
          <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            textAlign: "center",
            gap: 16,
            padding: "10px 14px",
          }}>
            <div style={{ fontSize: 52, filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.6))" }}>
              ⚔️
            </div>
            <div style={{
              fontSize: 22,
              fontWeight: 800,
              color: "#ff6b6b",
              textShadow: "0 2px 4px rgba(0,0,0,0.8)",
              letterSpacing: 0.5,
            }}>
              ¡HAS SIDO DERROTADO!
            </div>
            <div style={{
              fontSize: 14,
              color: "#f5e9d6",
              maxWidth: 340,
              lineHeight: 1.4,
            }}>
              {defeatReason}
            </div>
            <div style={{ fontSize: 13, color: "#d8c7ad", fontStyle: "italic" }}>
              Serás transportado de vuelta al pueblo.
            </div>
            <button
              onClick={() => {
                setShowDefeatModal(false);
                if (isLoaded && unityProvider) {
                  try { sendMessage("LoginManagerGO", "OnDefeatConfirmed"); } catch (err) {}
                  try { sendMessage("Character", "OnDefeatConfirmed"); } catch (err) {}
                }
              }}
              style={{
                marginTop: 8,
                background: "linear-gradient(90deg, #7a2b1a 0%, #a53b2b 100%)",
                border: "2px solid #d98a6c",
                color: "#fff4e0",
                fontWeight: 700,
                fontSize: 15,
                padding: "10px 28px",
                borderRadius: 10,
                cursor: "pointer",
                textShadow: "0 1px 2px rgba(0,0,0,0.5)",
                boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
                transition: "transform 0.08s, filter 0.1s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.03)";
                e.currentTarget.style.filter = "brightness(1.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.filter = "brightness(1)";
              }}
            >
              Volver al pueblo
            </button>
          </div>
        </GameModalFrame>
      )}

      {/* Modal / Panel del SANTUARIO DE REGENERACIÓN con barra de progreso */}
      {showSanctuaryModal && (
        <GameModalFrame
          title="Santuario de los Sabios"
          icon="✨"
          accent="#1a5a3a"
          size="sm"
          zIndex={50}
          flush={false}
        >
          <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            textAlign: "center",
            gap: 14,
            padding: "16px 20px",
          }}>
            <div style={{ fontSize: 44, filter: "drop-shadow(0 2px 6px rgba(0,255,150,0.4))" }}>
              💖
            </div>
            <div style={{
              fontSize: 20,
              fontWeight: 800,
              color: "#68d391",
              textShadow: "0 2px 4px rgba(0,0,0,0.8)",
              letterSpacing: 0.5,
            }}>
              REGENERANDO FUERZAS
            </div>
            <div style={{
              fontSize: 14,
              color: "#f5e9d6",
              maxWidth: 360,
              lineHeight: 1.4,
            }}>
              Recuperando {sanctuaryData.heartsToRecover} corazón(es) de vida...
              <br />
              <span style={{ fontSize: 12, color: "#d8c7ad", fontStyle: "italic" }}>
                (Penalización: 30 segundos por cada corazón)
              </span>
            </div>

            {/* Barra de progreso */}
            <div style={{
              width: "100%",
              maxWidth: 340,
              height: 22,
              background: "#1a1a1a",
              borderRadius: 12,
              border: "2px solid #4a3828",
              overflow: "hidden",
              position: "relative",
              boxShadow: "inset 0 2px 4px rgba(0,0,0,0.8)",
            }}>
              <div style={{
                width: `${sanctuaryProgress}%`,
                height: "100%",
                background: "linear-gradient(90deg, #276749 0%, #38a169 50%, #48bb78 100%)",
                transition: "width 0.15s ease",
                boxShadow: "0 0 10px rgba(72, 187, 120, 0.6)",
              }} />
              <span style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                fontSize: 11,
                fontWeight: 700,
                color: "#fff",
                textShadow: "0 1px 3px rgba(0,0,0,0.9)",
                pointerEvents: "none",
              }}>
                {Math.round(sanctuaryProgress)}%
              </span>
            </div>

            <div style={{ fontSize: 13, color: "#cbd5e0", fontWeight: 600 }}>
              Tiempo restante: <span style={{ color: "#fbd38d" }}>{sanctuarySecondsLeft}s</span>
            </div>

            <div style={{ fontSize: 11, color: "#a0aec0", fontStyle: "italic" }}>
              El personaje está en trance y no se puede mover mientras recupera su salud.
            </div>
          </div>
        </GameModalFrame>
      )}

      {/* Modal RPG de DESBLOQUEO POR CÓDIGO (interactuable LootConCodigo) */}
      {showCodeUnlock && (
        <GameModalFrame
          title="Objeto con Código"
          icon="🔐"
          accent="#2b4e7a"
          size="sm"
          zIndex={50}
          flush={false}
          closeHint="Cerrar (Esc)"
          onClose={() => cancelUnlockCode()}
        >
          <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            textAlign: "center",
            gap: 14,
            padding: "16px 20px",
          }}>
            <div style={{ fontSize: 44, filter: "drop-shadow(0 2px 6px rgba(80,160,255,0.4))" }}>
              🔐
            </div>
            <div style={{
              fontSize: 20,
              fontWeight: 800,
              color: "#90cdf4",
              textShadow: "0 2px 4px rgba(0,0,0,0.8)",
              letterSpacing: 0.5,
            }}>
              INTRODUCE EL CÓDIGO
            </div>
            <div style={{ fontSize: 14, color: "#f5e9d6", maxWidth: 360, lineHeight: 1.4 }}>
              Escribe la clave para desbloquear el botín.
            </div>

            <input
              type="text"
              value={codeUnlockValue}
              autoFocus
              maxLength={32}
              onChange={(e) => setCodeUnlockValue(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  submitUnlockCode();
                }
              }}
              placeholder="Código..."
              disabled={codeUnlockSubmitting}
              style={{
                width: "100%",
                maxWidth: 320,
                padding: "12px 14px",
                fontSize: 18,
                fontWeight: 700,
                textAlign: "center",
                borderRadius: 10,
                border: "2px solid #4a6a9a",
                outline: "none",
                background: "#f8fafc",
                color: "#1a2a3a",
                letterSpacing: 1,
              }}
            />

            {codeUnlockError && (
              <div style={{ fontSize: 13, color: "#ff7b7b", fontWeight: 600 }}>
                {codeUnlockError}
              </div>
            )}

            <div style={{ display: "flex", gap: 12, marginTop: 4 }}>
              <button
                onClick={() => submitUnlockCode()}
                disabled={codeUnlockSubmitting}
                style={{
                  background: "linear-gradient(90deg, #276749 0%, #38a169 100%)",
                  border: "2px solid #68d391",
                  color: "#fff4e0",
                  fontWeight: 700,
                  fontSize: 15,
                  padding: "10px 24px",
                  borderRadius: 10,
                  cursor: codeUnlockSubmitting ? "default" : "pointer",
                  opacity: codeUnlockSubmitting ? 0.6 : 1,
                  textShadow: "0 1px 2px rgba(0,0,0,0.5)",
                }}
              >
                {codeUnlockSubmitting ? "Comprobando..." : "Aceptar"}
              </button>
              <button
                onClick={() => cancelUnlockCode()}
                style={{
                  background: "linear-gradient(90deg, #7a2b1a 0%, #a53b2b 100%)",
                  border: "2px solid #d98a6c",
                  color: "#fff4e0",
                  fontWeight: 700,
                  fontSize: 15,
                  padding: "10px 24px",
                  borderRadius: 10,
                  cursor: "pointer",
                  textShadow: "0 1px 2px rgba(0,0,0,0.5)",
                }}
              >
                Cancelar
              </button>
            </div>
          </div>
        </GameModalFrame>
      )}
    </div>
  );
};

const ZeldaUnityGame: React.FC = () => {
  const { userId, user, alumne } = useContext(AuthContext);
  const navigate = useNavigate();
  const [errorMultiTab, setErrorMultiTab] = useState(false);
  const [checked, setChecked] = useState(false);

  // Comprobar que el acceso al juego proviene exclusivamente del botón "Iniciar Aventura" y que no esté en modo examen
  useEffect(() => {
    // Si el usuario es alumno y el aula está en modo examen, bloquear el acceso al juego
    if (user?.tipus === "2") {
      const aulesAlumne = (alumne as any)?.aules || (alumne as any)?.alumne?.aules || [];
      const hasExamMode = aulesAlumne.some((a: any) =>
        Boolean(a.isExamen === 1 || a.isExamen === true || a.is_examen === 1 || a.is_examen === true)
      );
      if (hasExamMode) {
        alert("El modo examen está activo en tu aula. No se permite acceder al juego.");
        navigate('/home', { replace: true });
        return;
      }
    }

    // Si la pestaña ya fue autorizada en esta sesión, permitir continuar
    if (sessionStorage.getItem('game_session_authorized')) {
      return;
    }

    const params = new URLSearchParams(window.location.search);
    const urlTicket = params.get('ticket');
    const localTicket = localStorage.getItem('game_launch_ticket');
    const ticketToVerify = urlTicket || localTicket;

    const isRecentTicket = ticketToVerify && !isNaN(Number(ticketToVerify)) && (Date.now() - Number(ticketToVerify) < 60000);

    if (!isRecentTicket) {
      alert("Solo se puede acceder al juego a través del botón 'Iniciar Aventura' en la pantalla de inicio.");
      navigate('/home', { replace: true });
      return;
    }

    // Marcar esta pestaña como autorizada
    sessionStorage.setItem('game_session_authorized', 'true');
    localStorage.removeItem('game_launch_ticket');

    // Limpiar el parámetro de la URL para que no quede visible
    if (urlTicket) {
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, [navigate]);

  useEffect(() => {
    if (!userId) {
      setChecked(true);
      return;
    }
    const lockKey = 'game_active_user_' + userId;
    const lastPing = localStorage.getItem(lockKey);
    // Give a 15-second threshold
    if (lastPing && Date.now() - parseInt(lastPing) < 15000) {
      setErrorMultiTab(true);
      setChecked(true);
      return;
    }

    const intervalId = setInterval(() => {
      localStorage.setItem(lockKey, Date.now().toString());
    }, 5000);

    // Initial set
    localStorage.setItem(lockKey, Date.now().toString());
    setChecked(true);

    return () => {
      clearInterval(intervalId);
      localStorage.removeItem(lockKey);
    };
  }, [userId]);

  if (!checked) return null;

  if (errorMultiTab) {
    return (
      <div style={{ display: 'flex', height: '100vh', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', background: '#000', color: 'white', fontFamily: 'sans-serif' }}>
        <h2 style={{ color: '#ff4d4f' }}>⚠ Error de Sessió</h2>
        <p style={{ fontSize: '18px', textAlign: 'center' }}>Ja tens el joc obert en una altra pestanya o finestra.</p>
        <p style={{ fontSize: '16px', color: '#ccc', textAlign: 'center', marginTop: '10px' }}>Si us plau, tanca l'altra pestanya per poder iniciar una nova sessió aquí.</p>
      </div>
    );
  }

  return (
    <App>
      <ZeldaUnityGameCore />
    </App>
  );
};

export default ZeldaUnityGame;
